import React from 'react';

interface RoundTableWithInvoice {
    id: number;
    name: string;
    number: number;
    billingEmail: string;
    selected: boolean;
}

interface EmailWizardStep3Props {
    roundTablesWithInvoices: RoundTableWithInvoice[];
    subject: string;
    cc: string;
    content: string;
    attachInvoice: boolean;
    onSendTest: () => void;
    onSkipTest: () => void;
}

const EmailWizardStep3: React.FC<EmailWizardStep3Props> = ({
    roundTablesWithInvoices,
    subject,
    cc,
    content,
    attachInvoice,
    onSendTest,
    onSkipTest,
}) => {
    const selectedTables = roundTablesWithInvoices.filter(t => t.selected);
    const randomTable = selectedTables.length > 0 
        ? selectedTables[Math.floor(Math.random() * selectedTables.length)]
        : null;

    // Replace placeholders for example
    // Note: This is for preview only. Actual implementation would fetch real member counts
    // and use the actual bank account information from the round table data
    const replacePlaceholders = (text: string, table: RoundTableWithInvoice | null) => {
        if (!table) return text;
        
        return text
            .replace(/\{\{name\}\}/g, table.name)
            .replace(/\{\{tableNumber\}\}/g, table.number.toString())
            .replace(/\{\{memberCount\}\}/g, '0') // TODO: Fetch actual member count from backend
            .replace(/\{\{bankAccount\}\}/g, 'IBAN: DE12345678901234567890'); // TODO: Use actual bank account from round table data
    };

    const exampleSubject = randomTable ? replacePlaceholders(subject, randomTable) : subject;
    const exampleContent = randomTable ? replacePlaceholders(content, randomTable) : content;

    return (
        <div className="wizard-step">
            <h3>Überprüfung</h3>
            
            {/* Summary */}
            <div className="email-summary">
                <div className="summary-item">
                    <strong>Anzahl der E-Mails:</strong> {selectedTables.length}
                </div>
                {attachInvoice && (
                    <div className="summary-item">
                        <strong>Anhang:</strong> Rechnung als PDF
                    </div>
                )}
            </div>

            {/* Example Email */}
            {randomTable && (
                <div className="email-preview">
                    <h4 style={{ marginTop: 0, marginBottom: '16px', color: '#333' }}>Beispiel E-Mail:</h4>
                    
                    <div className="email-preview-field">
                        <strong>An:</strong> {randomTable.billingEmail || 'keine E-Mail hinterlegt'}
                    </div>
                    
                    {cc && (
                        <div className="email-preview-field">
                            <strong>CC:</strong> {cc}
                        </div>
                    )}
                    
                    <div className="email-preview-field">
                        <strong>Betreff:</strong> {exampleSubject}
                    </div>
                    
                    <div className="email-preview-body">
                        <strong>Inhalt:</strong>
                        <div style={{ 
                            marginTop: '8px', 
                            padding: '12px', 
                            backgroundColor: '#fff', 
                            border: '1px solid #e9ecef',
                            borderRadius: '4px',
                            whiteSpace: 'pre-wrap',
                            fontFamily: 'inherit'
                        }}>
                            {exampleContent}
                        </div>
                    </div>
                </div>
            )}

            {selectedTables.length === 0 && (
                <div style={{ textAlign: 'center', padding: '40px 20px', color: '#6c757d' }}>
                    Keine Round Tables ausgewählt
                </div>
            )}

            {/* Action Buttons */}
            {selectedTables.length > 0 && (
                <div className="email-test-actions">
                    <button
                        type="button"
                        className="wizard-btn wizard-btn-test"
                        onClick={onSendTest}
                    >
                        Test-E-Mail senden
                    </button>
                    <button
                        type="button"
                        className="wizard-btn wizard-btn-skip"
                        onClick={onSkipTest}
                    >
                        Test überspringen
                    </button>
                </div>
            )}
        </div>
    );
};

export default EmailWizardStep3;
